import { render, staticRenderFns } from "./PeerGroupSettingsEditor.vue?vue&type=template&id=effde98c&scoped=true&"
import script from "./PeerGroupSettingsEditor.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupSettingsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupSettingsEditor.vue?vue&type=style&index=0&id=effde98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effde98c",
  null
  
)

export default component.exports